import { render, staticRenderFns } from "./ChampionshipsAddUpdate.vue?vue&type=template&id=18fd1a9c&"
import script from "./ChampionshipsAddUpdate.vue?vue&type=script&lang=js&"
export * from "./ChampionshipsAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipsAddUpdate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports